import type {
  Breakpoint,
  CreateTileRequest,
  DashboardContent,
  DashboardDetail,
  DashboardSummary,
  LayoutPatch,
  UpdateDashboardRequest,
  UpdateTileRequest,
} from "@csbi/contracts"
import { del, get, patch, post, put } from "../../shared/api/request.js"

const at = (idOrSlug: string) => `/dashboards/${encodeURIComponent(idOrSlug)}`

export const fetchDashboards = (signal?: AbortSignal) =>
  get<{ dashboards: DashboardSummary[] }>("/dashboards", signal)

export const fetchDashboard = (idOrSlug: string, signal?: AbortSignal) =>
  get<DashboardDetail>(at(idOrSlug), signal)

export const fetchHomeDashboard = (signal?: AbortSignal) =>
  get<{ dashboard: DashboardDetail | null }>("/dashboards/home", signal)

export const createDashboard = (body: { name: string; description?: string | null; copyFrom?: string }) =>
  post<{ id: string; slug: string }>("/dashboards", body)

export const updateDashboard = (idOrSlug: string, body: UpdateDashboardRequest) =>
  patch<DashboardDetail>(at(idOrSlug), body)

export const deleteDashboard = (idOrSlug: string) => del(at(idOrSlug))

export const putDashboardContent = (idOrSlug: string, body: DashboardContent) =>
  put<DashboardDetail>(`${at(idOrSlug)}/content`, body)

export const createTile = (idOrSlug: string, body: CreateTileRequest) =>
  post<{ id: string }>(`${at(idOrSlug)}/tiles`, body)

export const updateTile = (idOrSlug: string, tileId: string, body: UpdateTileRequest) =>
  patch<{ id: string }>(`${at(idOrSlug)}/tiles/${tileId}`, body)

export const deleteTile = (idOrSlug: string, tileId: string) => del(`${at(idOrSlug)}/tiles/${tileId}`)

export const saveLayout = (idOrSlug: string, breakpoint: Breakpoint, items: LayoutPatch["items"]) =>
  patch<{ breakpoint: Breakpoint; updated: number }>(`${at(idOrSlug)}/layout`, { breakpoint, items })
